import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Alert from '@material-ui/lab/Alert';

import Generic from 'components/Error/Generic';

class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    environment: PropTypes.string.isRequired,
  };

  static defaultProps = {
    errorMessage: '',
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  // eslint-disable-next-line class-methods-use-this
  componentDidCatch(error, errorInfo) {
    console.warn('Error Boundary caught', { error, errorInfo });
    if (window.sendError) {
      window.sendError({ error, ...errorInfo });
    }
    this.setState({ error, errorInfo });
  }

  render() {
    const { hasError, error, errorInfo } = this.state;
    const { errorMessage, environment } = this.props;
    if (hasError) {
      if (error && error.graphQLErrors) {
        const graphQLError = error.graphQLErrors[0];
        if (graphQLError && graphQLError.extensions && graphQLError.extensions.code) {
          switch (graphQLError.extensions.code) {
            case 'FORBIDDEN': {
              return (
                <Generic>
                  <p>{graphQLError.message}</p>
                </Generic>
              );
            }
            default: {
              break;
            }
          }
        }
      }

      if (!errorMessage && environment !== 'PROD' && environment !== 'BETA') {
        return (
          <div data-cy="error-boundary">
            <Alert severity="error">
              <h1 className="heading">Unhandled error</h1>
              <p>This will not display in production</p>
              <p>{error?.message}</p>
              <pre>{errorInfo?.componentStack}</pre>
            </Alert>
          </div>
        );
      }
      if (typeof errorMessage === 'string') {
        return <p>{errorMessage}</p>;
      }
      return errorMessage;
    }

    return this.props.children;
  }
}

const mapStateToProps = state => ({
  environment: state.config.environment,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ErrorBoundary);
